import React, {useLayoutEffect} from 'react'

/*
export default class GooglePermissionPopup extends Component {

    constructor(props) {
        super(props)
        this.state = {};
        this.handleLoad = this.handleLoad.bind(this);
    }

    handleLoad() {

        /!*
        * Show permissions popup
        * *!/

        let googlePermissionsHtml = `<div style="text-align: left;" class='contentHolder'>
        <h2 style="font-weight: bold;">Let’s Connect Your Google Account</h2>

<p style="font-weight: bold; text-align: left;">Why We Need Access to Your Data:</p>

<ul>
    <li><span style="font-weight: bold;">GA4:</span> Assign and filter annotations; view beautiful, user-friendly reports.</li>
    <li><span style="font-weight: bold;">Search Console:</span> View attractive reports on our dashboard.</li>
    <li><span style="font-weight: bold;">Tag Manager:</span> Auto-create annotations with script updates.</li>
</ul>
<br />
<p style="font-weight: bold; text-align: left;">Privacy & Security:</p>

<ul>
    <li><span style="font-weight: bold;">Privacy:</span> Your data is not shared; it's only used to enhance tool functionality.</li>
    <li><span style="font-weight: bold;">Security:</span> Data is encrypted; ISO27001 certification in progress.</li>
</ul>
        </div>`;

        swal.fire({
            iconHtml: '<figure class="m-0"><img src="/images/google-account.svg"></figure>',
            html: googlePermissionsHtml,
            width: 600,
            // confirmButtonClass: "m-0 p-0 border-0 rounded-0 bg-white",
            confirmButtonText: `Connect Google Account`,
            focusConfirm: false,
            // cancelButtonClass: "btn btn-secondary ml-5",
            showCloseButton: false,
            // showCancelButton: false,
            // cancelButtonText: 'Cancel',
            allowOutsideClick: true,
            backdrop: true,
            customClass: {
                popup: "confirmConnectionTo",
                htmlContainer: "confirmConnectionToContent",
                closeButton: 'btn-closeplanAlertPopup',
            },
        }).then(value => {
            if (value.isConfirmed) {
                if (this.props.userStartupConfig) {
                    var redirect_url = '/annotation';
                } else {
                    var redirect_url = window.location.pathname;
                }
                let query_string_obj = {
                    'google_analytics_perm': document.getElementById('google_analytics_perm') ? document.getElementById('google_analytics_perm').checked : true,
                    'google_search_console_perm': document.getElementById('google_search_console_perm') ? document.getElementById('google_search_console_perm').checked : true,
                    'google_ads_perm': document.getElementById('google_ads_perm') ? document.getElementById('google_ads_perm').checked : true,
                    'redirect_url': redirect_url,
                }
                let query_string = new URLSearchParams(query_string_obj).toString();
                // Save pathname in this storage without domain name
                if (this.props.userStartupConfig) {
                    localStorage.setItem("frontend_redirect_to", '/annotation');
                    localStorage.setItem("userStartupConfig_property_connect", `yes`);
                } else {
                    localStorage.setItem("frontend_redirect_to", window.location.pathname);
                }
                window.location = "/settings/google-account/create?" + query_string;
            }
        });
    }

    render() {
        return (
            <div>
                {this.handleLoad()}
            </div>
        )
    }
}
*/

const GooglePermissionPopup = (props) => {
    useLayoutEffect(() => {
        let googlePermissionsHtml = `<div style="text-align: left;" class='contentHolder'>
        <h2 style="font-weight: bold;">Let’s Connect Your Google Account</h2>

<p style="font-weight: bold; text-align: left;">Why We Need Access to Your Data:</p>

<ul>
    <li><span style="font-weight: bold;">GA4:</span> Assign and filter annotations; view beautiful, user-friendly reports.</li>
    <li><span style="font-weight: bold;">Search Console:</span> View attractive reports on our dashboard.</li>
    <li><span style="font-weight: bold;">Tag Manager:</span> Auto-create annotations with script updates.</li>
</ul>
<br />
<p style="font-weight: bold; text-align: left;">Privacy & Security:</p>

<ul>
    <li><span style="font-weight: bold;">Privacy:</span> Your data is not shared; it's only used to enhance tool functionality.</li>
    <li><span style="font-weight: bold;">Security:</span> Data is encrypted; ISO27001</li>
</ul>
        </div>`;

        swal.fire({
            iconHtml: '<figure class="m-0"><img src="/images/google-account.svg"></figure>',
            html: googlePermissionsHtml,
            width: 600,
            // confirmButtonClass: "m-0 p-0 border-0 rounded-0 bg-white",
            confirmButtonText: `Connect Google Account`,
            focusConfirm: false,
            // cancelButtonClass: "btn btn-secondary ml-5",
            showCloseButton: false,
            // showCancelButton: false,
            // cancelButtonText: 'Cancel',
            allowOutsideClick: true,
            backdrop: true,
            customClass: {
                popup: "confirmConnectionTo",
                htmlContainer: "confirmConnectionToContent",
                closeButton: 'btn-closeplanAlertPopup',
            },
        }).then(value => {
            if (value.isConfirmed) {
                if (props.userStartupConfig) {
                    var redirect_url = '/annotation';
                } else {
                    var redirect_url = window.location.pathname;
                }
                let query_string_obj = {
                    'google_analytics_perm': document.getElementById('google_analytics_perm') ? document.getElementById('google_analytics_perm').checked : true,
                    'google_search_console_perm': document.getElementById('google_search_console_perm') ? document.getElementById('google_search_console_perm').checked : true,
                    'google_ads_perm': document.getElementById('google_ads_perm') ? document.getElementById('google_ads_perm').checked : true,
                    'redirect_url': redirect_url,
                }
                let query_string = new URLSearchParams(query_string_obj).toString();
                // Save pathname in this storage without domain name
                if (props.userStartupConfig) {
                    localStorage.setItem("frontend_redirect_to", '/annotation');
                    localStorage.setItem("userStartupConfig_property_connect", `yes`);
                } else {
                    localStorage.setItem("frontend_redirect_to", window.location.pathname);
                }
                window.location = "/settings/google-account/create?" + query_string;
            } else if (value.isDismissed && props.onClosePermissionPopup) {
                props.onClosePermissionPopup();
            }
        });
    }, []);


    return <></>
}

export default GooglePermissionPopup;
